import styled from '@emotion/styled';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Icon, Styles } from '@contently/toolkit';

const { colors } = Styles;

const ListContainer = styled('div')`
  width: 500px;
  margin-top: 0;
  clear: both;
  position: relative;
  vertical-align: top;
  padding-right: 30px;
  padding-bottom: 30px;

  @media screen and (max-width: 480px) {
    width: 100%;
    padding-right: 0;
  }
`;

const ListItemWrapper = styled('div')`
  padding: 11px 5px;
  position: relative;
  border-top: 1px solid #d4d4d4;
`;

const LiFlexWrapper = styled('li')`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 3px 0 3px 15px;
  border-bottom: 1px dotted #d4d4d4;
`;

const ListItemFlexColumn = styled('div')`
  flex-grow: 1;
  flex-basis: 0;
`;

const ListItemFlexColumnNum = styled(ListItemFlexColumn)`
  text-align: right;
`;

const IndentedLiFlexWrapperBold = styled(LiFlexWrapper)`
  width: 90%;
  margin-left: 10%;
  font-weight: bold;
`;

const IndentedLiFlexWrapperItalic = styled(LiFlexWrapper)`
  width: 90%;
  margin-left: 10%;
  font-style: italic;
`;

const listRowPropTypes = PropTypes.shape({
  leftCol: PropTypes.string,
  rightCol: PropTypes.string
}).isRequired

const tooltipProptypes = PropTypes.shape({
  tooltip: PropTypes.node
}).isRequired

const listRowWithTooltipPropTypes = PropTypes.shape({
  ...listRowPropTypes,
  ...tooltipProptypes
}).isRequired

const InnerListRow = ({ leftCol, rightCol }) => (
  <LiFlexWrapper>
    <ListItemFlexColumn>{leftCol}</ListItemFlexColumn>
    <ListItemFlexColumnNum>{rightCol}</ListItemFlexColumnNum>
  </LiFlexWrapper>
);

InnerListRow.propTypes = {
  ...listRowPropTypes
};

const RowTooltip = ({ tooltip }) => (
  <Tooltip content={tooltip} bottom>
    <Icon type="c-question" color={colors.blue.primary} withTextLeft />
  </Tooltip>
);

RowTooltip.propTypes = {
  ...tooltipProptypes
};

const InnerListRowWithTooltip = ({ leftCol, rightCol, tooltip }) => (
  <LiFlexWrapper>
    <ListItemFlexColumn>{leftCol}
      <RowTooltip tooltip={tooltip} />
    </ListItemFlexColumn>
    <ListItemFlexColumnNum>{rightCol}</ListItemFlexColumnNum>
  </LiFlexWrapper>
);

InnerListRowWithTooltip.propTypes = {
  ...listRowWithTooltipPropTypes
};

const SubInnerListRow = ({ leftCol, rightCol, tooltip }) => (
  <Fragment>
    <ListItemFlexColumn>{leftCol}
      <RowTooltip tooltip={tooltip} />
    </ListItemFlexColumn>
    <ListItemFlexColumnNum>{rightCol}</ListItemFlexColumnNum>
  </Fragment>
);

SubInnerListRow.propTypes = {
  ...listRowWithTooltipPropTypes
};

const SubInnerListRowBold = ({ leftCol, rightCol, tooltip }) => (
  <IndentedLiFlexWrapperBold>
    <SubInnerListRow leftCol={leftCol} rightCol={rightCol} tooltip={tooltip} />
  </IndentedLiFlexWrapperBold>
);

SubInnerListRowBold.propTypes = {
  ...listRowWithTooltipPropTypes
};

const SubInnerListRowItalic = ({ leftCol, rightCol, tooltip }) => (
  <IndentedLiFlexWrapperItalic>
    <SubInnerListRow leftCol={leftCol} rightCol={rightCol} tooltip={tooltip} />
  </IndentedLiFlexWrapperItalic>
);

SubInnerListRowItalic.propTypes = {
  ...listRowWithTooltipPropTypes
};

export {
  RowTooltip,
  ListContainer,
  ListItemWrapper,
  InnerListRow,
  InnerListRowWithTooltip,
  SubInnerListRowBold,
  SubInnerListRowItalic
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/transactions/styled/base_components.jsx